export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/piano-icon.svg?e906b53e9b6537dc04156bf3f7a977c7";